export interface DecoratedGroupedOpenQuestionAnswers {
  collapsed: string;
  question: GroupedOpenQuestionAnswer;
  decoratedStatus?: string | null;
}

export interface Referrer {
  avatarThumbUrl: string;
  firstName: string;
  lastName: string;
  anonymizedAt: string | null;
  hasAvatar?: boolean;
  initials?: string;
}

export interface GroupedOpenQuestionAnswer {
  openQuestionAnswers: OpenQuestionAnswer[];
  updatedAt?: string;
  createdAt?: string;
  offer: null | { id: number | null; status: string | null; title: string };
  user?: Referrer;
}

export interface OpenQuestionAnswer {
  id: number;
}

export enum QuestionKind {
  Boolean = 'boolean',
  Dropdown = 'dropdown',
  File = 'file',
  Info = 'info',
  MultipleChoice = 'multi_choice',
  ScaleRating = 'scale_rating',
  Scorecard = 'scorecard',
  SingleChoice = 'single_choice',
  String = 'string',
  Text = 'text',
  Video = 'video',
  Legal = 'legal',

  Date = 'date',
  Number = 'number',
  Salary = 'salary',
}
